export const statusColorsStyles = {
  green: "#4CD964",
  gray: "#858E99",
  red: "#FF0000",
  yellow: "#FFCE00",
  blue: "#2962FF",
  orange: "#FF9900",
  black: "#000000",
};
